import { render, staticRenderFns } from "./Publishing.vue?vue&type=template&id=74775868&scoped=true&"
import script from "./Publishing.vue?vue&type=script&lang=js&"
export * from "./Publishing.vue?vue&type=script&lang=js&"
import style0 from "./Publishing.vue?vue&type=style&index=0&id=74775868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74775868",
  null
  
)

export default component.exports